import * as types from './mutation-types'

const mutations = {
  [types.SET_NOT_READ] (state, notReadNumber) {
    state.notReadNumber = notReadNumber
  },
  [types.SET_AUTHTREE] (state, authTree) {
    state.authTree = authTree
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js